fragment MailChimpListBasic on MailChimpList {
    id
    name
}
